import { JBGShopify } from '$services/shopify'

export default defineNuxtPlugin(({ $i18n, $listrak, $launchDarkly }) => {
    const runtimeConfig = useRuntimeConfig()
    const shopifyProvider = new JBGShopify(<JBGShopify.InitOptions>{
        ...runtimeConfig.public.shopify,
        locale: $i18n.locale.value,
        countryCode: useCookie('cloudfront-viewer-country')?.value || 'US',
        listrak: $listrak.ltk,
        launchDarkly: $launchDarkly
    })

    return {
        provide: {
            shopify: shopifyProvider
        }
    }
})
